<style scoped>
</style>

<template>
	<div class="vue-box">
		<div class="c-panel">

			<!-- 参数栏 -->
			<div class="c-title">班级列表</div>
			<el-form size="mini" :inline="true" @submit.native.prevent >
        <el-form-item style="min-width: 0px;">
        <el-button type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
        </el-form-item>
        <br>
        <el-form-item label="年份：">
          <el-select size="mini" v-model="p.year">
            <el-option label="不限" :value="''"></el-option>
            <el-option v-for="year in yearList" :label="year" :value="year" :key="year"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="老师：">
          <el-select size="mini" v-model="p.teaId">
            <el-option label="不限" :value="''"></el-option>
            <el-option v-for="tea in teacherList" :label="tea.name" :value="tea.id" :key="tea.id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="季度：">
          <el-select size="mini" v-model="p.quarter">
            <el-option label="不限" :value="''"></el-option>
            <el-option label="春季" :value="1"></el-option>
            <el-option label="暑假" :value="2"></el-option>
            <el-option label="秋季" :value="3"></el-option>
            <el-option label="寒假" :value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="科目：">
          <el-select size="mini" v-model="p.subId">
            <el-option label="不限" :value="''"></el-option>
            <el-option v-for="sub in subList" :label="sub.name" :value="sub.id" :key="sub.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="校区：">
          <el-select size="mini" v-model="p.campus">
            <el-option label="不限" :value="''"></el-option>
            <el-option v-for="campus in campusList" :label="campus.name" :value="campus.id" :key="campus.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态：">
          <el-select size="mini" v-model="p.status">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="禁用" :value="1"></el-option>
            <el-option label="不限" :value="''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="min-width: 0px;">
          <el-button type="primary" icon="el-icon-search" @click="p.pageNo = 1; f5()">查询</el-button>

        </el-form-item>
			</el-form>
			<!-- 数据列表 -->
			<div class="c-title">数据列表</div>
			<el-table :data="dataList" size="mini">
        <el-table-column label="班级状态" width="80px">
          <template slot-scope="s">
            <el-tag class="c-tag" effect="dark" size="mini" color="#282" v-if="s.row.status==0" @click="changeStatus(s.row.id,s.row.status)">正常</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#f22" v-if="s.row.status==1" @click="changeStatus(s.row.id,s.row.status)">禁用</el-tag>
          </template>
        </el-table-column>
				<el-table-column label="名称" prop="name"  width="200px"></el-table-column>
				<el-table-column label="科目" width="200px">
					<template slot-scope="s">
						<span style="color: #000000; ">{{getSubName(s.row.subId)}}</span>
					</template>
				</el-table-column>

        <el-table-column label="总课时" prop="hour" width="100px"></el-table-column>
        <el-table-column label="校区"  width="100px">
          <template slot-scope="s">
            <span style="color: #000000; ">{{getCampusName(s.row.campus)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="带班老师" width="200px">
          <template slot-scope="s">
            <span style="color: #000000; ">{{getTeacherName(s.row.teaId)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建日期" width="150px">
          <template slot-scope="s"><span>{{sa.forDate(s.row.createTime, 2)}}</span></template>
        </el-table-column>
				<el-table-column label="操作" width="240px">
					<template slot-scope="s">
						<el-button class="c-btn" type="success"  icon="el-icon-view" @click="openClazzCard(s.row)">课表</el-button>
            <el-button class="c-btn" type="warning" icon="el-icon-view" @click="viewStu(s.row)">学生</el-button>
						<el-button class="c-btn" type="primary" icon="el-icon-edit" @click="update(s.row)">修改</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="page-box">
				<el-pagination background
					layout="total, prev, pager, next, sizes, jumper"
					:current-page.sync="p.pageNo"
					:page-size.sync="p.pageSize"
					:total="dataCount"
					:page-sizes="[1, 10, 20, 30, 40, 50, 100]"
					@current-change="f5()"
					@size-change="f5()">
				</el-pagination>
			</div>
		</div>

		<!-- 增改组件 -->
		<add-or-update ref="add-or-update"></add-or-update>
	</div>
</template>

<script>
	import addOrUpdate from './clazz-list-add.vue';
	export default {
		components: {
			addOrUpdate
		},
		data() {
			return {
			  yearList:[],
			  subList:[],
        teacherList:[],
				p: {		// 查询参数
					pageNo: 1,
					pageSize: 10,
          teaId:'',
          status:0,
          subId:'',
          quarter:'',
          year:'',
          campus:''
				},
				dataCount: 0,
				dataList: [],		// 数据集合
        campusList:[],
			}
		},
		methods: {
			// 刷新
			f5: function(){
        let data = {
          subId:this.p.subId,
          pageNum:this.p.pageNo,
          pageSize:this.p.pageSize,
          teaId:this.p.teaId,
          status:this.p.status,
          quarter:this.p.quarter,
          campus:this.p.campus,
          year:this.p.year
        }
				this.sa.ajax('api/psdAdmin/clazz/getList',
            data,
            function(res){
				  if(res.code == 0) {
            this.dataList = res.data.data;	// 数据
            this.dataCount = res.data.pageCount;	// 分页
            console.log(res.data);
          }else{
            this.dataList=[];
            this.dataCount=0;
            this.sa.error(res.msg || '会员列表获取失败');
          }
				}.bind(this)/*, {res: mockDataList}*/);
			},
      openClazzCard:function (data){
        var tab = {id: '101-'+data.id, name: '['+data.name+'] 课表', view: () => import('@/sa-view/clazzCard/clazz-card-list.vue'), params:{id:data.id,name:data.name}};
        this.sa_admin.showTab(tab);
      },
			// 添加
			add: function () {
				this.$refs['add-or-update'].open(0);
			},
			// 修改
			update: function (data) {
				this.$refs['add-or-update'].open(data.id);
			},
			// 删除
      viewStu: function (data) {
        var tab = {id: '102-'+data.id, name: '['+data.name+'] 学生列表', view: () => import('@/sa-view/clazz/clazz-stu-list.vue'), params:{id:data.id,name:data.name}};
        this.sa_admin.showTab(tab);
			},
      changeStatus:function (id,status){
			  let _this = this;
			  if(status == 0){
          this.sa.confirm("确定禁用该班级吗",function (){
            console.log("禁用");
            _this.sa.ajax('api/psdAdmin/clazz/switchClazzStatus',
                {id:id,status:'1'},
                function(res){
                  if(res.code=='0'){
                    _this.sa.alert("已禁用",function (){
                      _this.f5();
                    });
                  }else{
                    _this.sa.error("禁用失败");
                  }
                }.bind(this));
          });
        }else{
          this.sa.confirm("确定启用该班级吗",function (){
            _this.sa.ajax('api/psdAdmin/clazz/switchClazzStatus',
                {id:id,status:'0'},
                function(res){
                  if(res.code=='0'){
                    _this.sa.alert("已启用",function (){
                      _this.f5();
                    });

                  }else{
                    _this.sa.error("启用失败");
                  }
                }.bind(this));
          });
        }
      },
      getSubList:function (){
        this.sa.ajax('api/psdAdmin/subject/getList',
            {},
            function(res){
              this.subList = res.data;
              console.log('科目',res.data);
            }.bind(this),{async:false});
      },
      getSubName:function (id){
        for(let i=0;i<this.subList.length;i++){
          if(this.subList[i].id == id){
            return this.subList[i].name;
          }
        }
        return id;
      },
      getTeacherList:function (){
        this.sa.ajax('api/psdAdmin/teacher/getList',
            {},
            function(res){
              this.teacherList = res.data;
              console.log('老师',res.data);
            }.bind(this),{async:false});
      },
      getTeacherName:function (id){
        for(let i=0;i<this.teacherList.length;i++){
          if(this.teacherList[i].id == id){
            return this.teacherList[i].name;
          }
        }
        return id;
      },
      getYearList:function (){
        this.sa.ajax('api/psdAdmin/clazz/getYearList',
            {},
            function(res){
              this.yearList = res.data;
              console.log('年份',res.data);
            }.bind(this),{async:false});
      },
      getCampusList:function (){
        this.sa.ajax('api/psdAdmin/campus/getList',
            {},
            function(res){
              this.campusList = res.data;
              console.log('校区',res.data);
            }.bind(this),{async:false});
      },
      getCampusName: function (value) {
        for(let i=0;i<this.campusList.length;i++){
          if(this.campusList[i].id == value){
            return this.campusList[i].name;
          }
        }
        return value;
      },
		},
		created: function(){
		  this.getCampusList();
      this.getTeacherList();
      this.getSubList();
      this.getYearList();
			this.f5();
			// this.$notify.info({
			// 	title: '消息',
			// 	message: '本页面展示表格的常见显示方式'
			// });
		},
    filters: {

    }
	}
</script>
